/**
 * Component is used to show store's phone based on its identifier.
 *
 * @attr {string} title-phone - The title for phone block
 * @attr {string} store-code - an identifier of a store
 * @prop {string} phoneNumber - an phone Number of a certain store
 *
 */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import { actions, selectors } from '@elab/core/store/store-details';
import connect from '@elab/core/store/connect';

export class StoreDetailsPhone extends SimpleLitElement {
    static get properties() {
        return {
            storeUid: {
                type: String,
                attribute: 'store-code',
            },
            titlePhone: {
                type: String,
                attribute: 'title-phone',
            },
            callLink: {
                type: Boolean,
                attribute: 'call-link',
            },
            phoneNumber: {
                type: String,
            },
        };
    }

    firstUpdated() {
        this.dispatchEvent(new CustomEvent('get-store-details'));
    }

    getPhoneNumberTemplate = () => html`
        <div class="${this.callLink ? 'button' : ''}  phone-card">
            <span class="phone-card__phone icon"></span>
            <span class="phone-card__title">${this.titlePhone}:</span>
            <div class="phone-card__number">
                ${this.phoneNumber}
            </div>
        </div>
    `;

    render() {
        return this.phoneNumber
            ? html`
                  ${this.callLink
                      ? html`
                            <a href="tel:${this.phoneNumber}" class="phone-card-button">
                                ${this.getPhoneNumberTemplate()}
                            </a>
                        `
                      : this.getPhoneNumberTemplate()}
              `
            : html``;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    'get-store-details': () => dispatch(actions.getStoreDetails(ctx.storeUid)),
});

const mapStateToProps = state => {
    const store = selectors.getDataStore(state) || {};
    return {
        phoneNumber: store.address && store.address.phone,
    };
};

export default () => {
    customElements.define(
        'e2-store-details-phone',
        connect(mapStateToProps, mapDispatchToEvents)(StoreDetailsPhone),
    );
};
